import { getTranslateByKey, isEmpty } from "@/main/services/utils";

interface NotQuotedOrAwaitingAnswerInfoProps {
	reason?: string;
	reasonDescription?: string;
	notQuoted?: boolean;
	isQuoteOpen?: boolean;
	isQuoteManual?: boolean;
}

export default function NotQuotedOrAwaitingAnswerInfo({
	notQuoted,
	reasonDescription,
	reason,
	isQuoteManual,
}: NotQuotedOrAwaitingAnswerInfoProps) {
	function renderAdditionalInfo() {
		if (notQuoted) {
			const renderReason = isEmpty(reasonDescription) ? `(${reason})` : `${reason} (${reasonDescription})`;
			return (
				<div className="d-flex flex-column">
					<span>{renderReason}</span>
					{getTranslateByKey("information.notAvailable")}
				</div>
			);
		}
		if (isQuoteManual) {
			return <>{getTranslateByKey("information.didNotAnswer")}</>;
		}
		return <>{getTranslateByKey("information.awaitingAnswer")}</>;
	}

	return renderAdditionalInfo();
}
